<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <h1 class="mb-2">Witamy na Baza Typera!</h1>
        <p>Twoje źródło statystyk do tworzenia najlepszych typów.
          <br>
          Sprawdź nasze statystyki aby zwiększyć swoje szanse na wygraną.
        </p>
        <v-btn href="/football/today/1x2" color="primary">
          Przejdź
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from '@/api'

export default {
  data: () => ({
  }),
  mounted () {
  }
};
</script>
